import type { ProductCostBreakdownRow } from "./types"

import type { GoodsReceipt } from "@/graphql/codegen/graphql"
import { getGoodsReceiptPurchaseOrderLines } from "@/screens/WarehouseReceiving/utils"

export const transformGoodsReceiptsToRows = (
  goodsReceipts: GoodsReceipt[],
  productId: number
): ProductCostBreakdownRow[] => {
  const rows: ProductCostBreakdownRow[] = []

  goodsReceipts.forEach((goodsReceipt) => {
    const purchaseOrderLines = getGoodsReceiptPurchaseOrderLines(goodsReceipt)

    purchaseOrderLines
      .filter((purchaseOrderLine) => purchaseOrderLine.product?.productId === productId)
      .forEach((purchaseOrderLine) => {
        rows.push({
          id: `${goodsReceipt.goodsReceiptId}-${purchaseOrderLine.orderLineId}`,
          goodsReceipt,
          purchaseOrderLine,
        })
      })
  })

  return rows
}
